import React, {useState} from 'react';
import cx from 'classnames';

import LessonCard from './LessonCard';
import CollapserThing from '../../components/CollapserThing';
import {CaretIcon} from '../../components/svg';
import {Badge} from '../../components/Badge';
import {isNewLesson} from '../../util';

const ModuleCard = ({
  module,
  courseSlug,
  courseIsNew,
  trackSlug,
  onClickLesson,
  index,
}) => {
  const [expanded, setExpanded] = useState(index === 0);
  const videoCount = module.lessons.filter((l) => !!l.video).length;
  const newLessonCount = module.lessons.filter(isNewLesson).length;
  const isExpandable = !module.comingSoon && module.lessons?.length > 0;

  return (
    <div
      className="flex flex-col border-b border-gray-200 last:border-0"
      name={`${courseSlug}_${module.slug}`}
    >
      <button
        type="button"
        onClick={() => setExpanded(!expanded)}
        className="flex-grow bg-gray-50"
        disabled={!isExpandable}
      >
        <div className="flex items-center text-xs sm:text-sm py-4 px-5 justify-between">
          <span className="text-gray-800 font-semibold mr-2 truncate text-ellipsis">
            <CaretIcon className={cx(
              'h-3 w-3 flex-shrink-0 transform transition-transform mb-0.5 mr-2',
              {'-rotate-90': expanded, '-rotate-180': !expanded},
            )}
            />
            {module.title}
          </span>
          {module.comingSoon ? (
            <div className="rounded-full bg-indigo-100 px-2 py-0.5 font-medium text-xs text-indigo-600 whitespace-nowrap">
              Coming soon
            </div>
          ) : (
            <div>
              {/* Don't show new lesson count if whole course is new */}
              {!courseIsNew && newLessonCount > 0 && (
                <Badge className="mr-3">
                  {`${newLessonCount} new`}
                </Badge>
              )}
              <span className="text-gray-500">
                {`${module.lessons.length > 1 ? `${module.lessons.length} lessons` : '1 lesson'} ${videoCount > 0 ? ` • ${videoCount} video${videoCount > 1 ? 's' : ''}` : ''}`}
              </span>
            </div>
          )}
        </div>
      </button>
      <CollapserThing visible={expanded}>
        {/* Empty div is hack to make LessonCard borders work */}
        <div />
        {module.lessons.map((lesson, idx) => (
          <LessonCard
            key={lesson.slug}
            lesson={lesson}
            courseSlug={courseSlug}
            courseIsNew={courseIsNew}
            trackSlug={trackSlug}
            onClickLesson={onClickLesson}
          />
        ))}
      </CollapserThing>
    </div>
  );
};

export default ModuleCard;
